export default __webpack_public_path__ + "static/427-907ffab0c0ce3e12596352332687ede6.gif";